import { TezosToolkit } from "@taquito/taquito";
import { BeaconWallet } from "@taquito/beacon-wallet";
import config from "../config";

const preferredNetwork = "mainnet";
const options = {
  name: "Pixel Place",
  iconUrl: "https://carsonkompon.github.io/PixelPlace/logo192.png", //TODO: Change
  preferredNetwork: preferredNetwork,
};
const rpcURL = "https://mainnet.smartpy.io";
const wallet = new BeaconWallet(options);

const getActiveAccount = async () => {
  return await wallet.client.getActiveAccount();
};

const connectWallet = async () => {
  let account = await wallet.client.getActiveAccount();

  if (!account) {
    await wallet.requestPermissions({
      network: { type: preferredNetwork },
    });
    account = await wallet.client.getActiveAccount();
  }
  return { success: true, wallet: account.address };
};

const disconnectWallet = async () => {
  await wallet.disconnect();
  return { success: true, wallet: null };
};

const checkIfWalletConnected = async (wallet) => {
  try {
    const activeAccount = await wallet.client.getActiveAccount();
    if (!activeAccount) {
      await wallet.client.requestPermissions({
        type: { network: preferredNetwork },
      });
    }
    return {
      success: true,
    };
  } catch (error) {
    return {
      success: false,
      error,
    };
  }
};

export const getStorage = async (callback) => {
  const tezos = new TezosToolkit(rpcURL);
  const contract = await tezos.contract.at(config.contractAddress);
  //const operation = await contract.methods.default(name).send();
  await contract.storage()
  .then((myStorage) => {
    callback(myStorage);
  })
};

export const setPixel = async (_col, _x, _y, _callback, _success, _failure) => {
  const response = await checkIfWalletConnected(wallet);

  if (response.success) {
    const tezos = new TezosToolkit(rpcURL);
    tezos.setWalletProvider(wallet);
    const contract = await tezos.wallet.at(config.contractAddress);
    //const operation = await contract.methods.default(name).send();
    await contract.methods.setPixel(_col,_x,_y).send({amount: 0.01})
    .then((op) => {
      console.log("waiting for confirmation...");
      return op.confirmation().then(() => op.opHash);
    })
    .then(() => {
      _success();
    })
    .catch((err) => {
      console.log(err);
      _failure();
    })
    _callback();
  }else{
    _callback();
    _failure();
  }
};

export {
  connectWallet,
  disconnectWallet,
  getActiveAccount,
  checkIfWalletConnected,
};
